<nav class="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow">
  <a class="navbar-brand col-sm-3 col-md-2 mr-0" href="#">Panneau de contrôle OBS - Yu-Gi-Oh!</a>
  <a class="navbar-brand col-sm-3 col-md-2 mr-0" href="/infos">Liens OBS</a>
  <a class="navbar-brand col-sm-3 col-md-2 mr-0" href="/panel-pixel">Pixel</a>
  <a class="navbar-brand col-sm-6 col-md-2 mr-0" href="/logout">Déconnexion</a>
  <a (click)="showRoom()" class="navbar-brand col-sm-3 col-md-2 mr-0 text-danger">room :
    <span *ngIf="isShowed" class="room">{{authService.getToken()}}</span></a>
</nav>
